import type { FC, ReactNode } from 'react';
import { TableCell } from '@mui/material';

import { styles } from '../table.styles';

interface TicketTableCell {
  isHead?: boolean;
  sxOverride?: Record<string, string | number>;
  children?: ReactNode;
}

const TicketTableCell: FC<TicketTableCell> = ({
  children,
  isHead,
  sxOverride,
}) => (
  <TableCell
    {...(isHead ? { component: 'th' } : {})}
    sx={(theme) => ({
      ...styles.tableCell(theme, isHead),
      ...sxOverride,
    })}
  >
    {children}
  </TableCell>
);

export default TicketTableCell;
